import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from '../slices';
import { useNavigate } from 'react-router';
import * as Cases from '../slices/casesSlice';
import * as UI from '../slices/uiSlice';
import NavMenu from './navmenu';
import NavBar from './navbar';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import hub_logo from '../assets/Main_Hub_Icon_Large.svg';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { AnyAction } from '@reduxjs/toolkit';
import HistoryItem from './historyitem';
import { useEffect, useState } from 'react';
import OpenCaseIconBlue from '../assets/open-case-icon-blue.svg';
import CaseDetailsIconBlue from '../assets/case-details-icon-blue.svg';
import ActionsIconBlue from '../assets/actions-icon-blue.svg';
import FormsAndReportsIcon from '../assets/forms-and-reports-icon.svg';
import MeetTheTeamIconBlue from '../assets/meet-the-team-icon-blue.svg';
import WishlistIconBlue from '../assets/wishlist-icon-blue.svg';

const HistoryList = () => {
	const cases = useAppSelector(state => state.cases);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [tab, setTab] = useState('IF');
	const [tabNotifications, setTabNotifications] = useState({ IF: 0, RP: 0, SC: 0, MF: 0 });

	useEffect(() => {
		let updatedTabNotifications = { IF: 0, RP: 0, SC: 0, MF: 0 };
		for (const h of cases.case.historyData) {
			if (h.actioned !== h.actions) {
				if (updatedTabNotifications.hasOwnProperty(h.tab)) {
					updatedTabNotifications[h.tab as keyof typeof updatedTabNotifications]++;
				}
			}
		}
		setTabNotifications(updatedTabNotifications);
	}, [tab]);

	useEffect(() => {
		if (!cases.case.caseno) {
			navigate('/hub');
		}
	}, [])

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	const openCase = () => {
		navigate('/case');
	}

	const openCaseDetails = () => {
		navigate('/case-details');
	}

	const openActions = () => {
		navigate('/actions');
	}

	const openHistory = () => {
		navigate('/historylist');
	}

	const openTeam = () => {
		navigate('/team');
	}

	const wishList = () => {
		if (cases.case.details && cases.case.details.wishlisted) {
			dispatch(UI.setWishlistEditPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		} else {
			dispatch(UI.setWishlistPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		}
	}

	const getFilteredHistory = (t: string): Cases.caseHistoryItemState[] => {
		let history: Cases.caseHistoryItemState[] = [];

		for (const h of cases.case.historyData) {
			if (h.tab === t) {
				history.push(h);
			}
		}

		return history;
	}

	return (
		<div className="Home" style={{ position: 'relative' }}>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={hub_logo} alt='Hub-Logo' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Forms & Reports - {cases.case.caseno}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row100 topButtonContainer" style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', top: '150px', left: '2%', zIndex: 995 }}>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCase()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={OpenCaseIconBlue} alt='Milestones-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Milestones</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCaseDetails()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '45px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={CaseDetailsIconBlue} alt='CaseDetails-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Case Details</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openActions()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={ActionsIconBlue} alt='Actions-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Actions</div>
							{cases.case.details && cases.case.details.unviewActions.length > 0 && <div style={{ height: '19px', width: '19px', marginLeft: '10px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{cases.case.details.unviewActions.length}</div>}
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openHistory()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={FormsAndReportsIcon} alt='Forms&Reports-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Forms & Reports</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openTeam()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={MeetTheTeamIconBlue} alt='Team-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className={(cases.case.details?.wishlisted ? 'buttonGreenRounded' : 'buttonPurpleSecondary')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => wishList()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={WishlistIconBlue} alt='Wishlist-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Wishlist{(cases.case.details?.wishlisted ? ' - ' + cases.case.details.wishlisted : '')}</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isWishlisting &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
				</div>
				<div className='reportsTableWrapper' style={{ position: 'absolute', top: 205, left: 0, right: 0, bottom: 0 }}>
					<div style={{ margin: 'auto', padding: '16px 2%', color: 'black' }}>
						{tab === 'IF' &&
							<div>
								<div style={{ display: 'flex', width: '96%' }}>
									<div className='tab' style={{ position: 'relative', height: '21px', backgroundColor: '#40bedf', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('IF')}>
										<p>Initial Forms</p>
										{tabNotifications.IF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.IF}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('RP')}>
										<p>Reports</p>
										{tabNotifications.RP > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.RP}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('SC')}>
										<p>Searches</p>
										{tabNotifications.SC > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.SC}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('MF')}>
										<p>Mortgages/Finances</p>
										{tabNotifications.MF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.MF}</span>}
									</div>
								</div>
								<div style={{ position: 'absolute', top: 65, left: 0, right: 0, bottom: 2, overflowY: 'scroll' }} onScroll={handleScroll}>
									<div style={{ margin: 'auto', padding: '0px 2%', color: 'black' }}>
										{getFilteredHistory('IF').map((item: Cases.caseHistoryItemState) => (
											<HistoryItem key={item.historyrowid} {...item} />
										))}
										{getFilteredHistory('IF').length === 0 &&
											<div>No Initial Forms Found</div>
										}
									</div>
								</div>
							</div>
						}
						{tab === 'RP' &&
							<div>
								<div style={{ display: 'flex' }}>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('IF')}>
										<p>Initial Forms</p>
										{tabNotifications.IF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.IF}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', backgroundColor: '#40bedf', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('RP')}>
										<p>Reports</p>
										{tabNotifications.RP > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.RP}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('SC')}>
										<p>Searches</p>
										{tabNotifications.SC > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.SC}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('MF')}>
										<p>Mortgages/Finances</p>
										{tabNotifications.MF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.MF}</span>}
									</div>
								</div>
								<div style={{ position: 'absolute', top: 65, left: 0, right: 0, bottom: 2, overflowY: 'scroll' }} onScroll={handleScroll}>
									<div style={{ margin: 'auto', padding: '0px 2%', color: 'black' }}>
										{getFilteredHistory('RP').map((item: Cases.caseHistoryItemState) => (
											<HistoryItem key={item.historyrowid} {...item} />
										))}
										{getFilteredHistory('RP').length === 0 &&
											<div style={{marginLeft: '4px'}}>No Reports Found</div>
										}
									</div>
								</div>
							</div>
						}
						{tab === 'SC' &&
							<div>
								<div style={{ display: 'flex' }}>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('IF')}>
										<p>Initial Forms</p>
										{tabNotifications.IF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.IF}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('RP')}>
										<p>Reports</p>
										{tabNotifications.RP > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.RP}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', backgroundColor: '#40bedf', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('SC')}>
										<p>Searches</p>
										{tabNotifications.SC > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.SC}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('MF')}>
										<p>Mortgages/Finances</p>
										{tabNotifications.MF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.MF}</span>}
									</div>
								</div>
								<div style={{ position: 'absolute', top: 65, left: 0, right: 0, bottom: 2, overflowY: 'scroll' }} onScroll={handleScroll}>
									<div style={{ margin: 'auto', padding: '0px 2%', color: 'black' }}>
										{getFilteredHistory('SC').map((item: Cases.caseHistoryItemState) => (
											<HistoryItem key={item.historyrowid} {...item} />
										))}
										{getFilteredHistory('SC').length === 0 &&
											<div style={{marginLeft: '4px'}}>No Searches Found</div>
										}
									</div>
								</div>
							</div>
						}
						{tab === 'MF' &&
							<div>
								<div style={{ display: 'flex' }}>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('IF')}>
										<p>Initial Forms</p>
										{tabNotifications.IF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.IF}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('RP')}>
										<p>Reports</p>
										{tabNotifications.RP > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.RP}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('SC')}>
										<p>Searches</p>
										{tabNotifications.SC > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.SC}</span>}
									</div>
									<div className='tab' style={{ position: 'relative', height: '21px', backgroundColor: '#40bedf', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }} onClick={() => setTab('MF')}>
										<p>Mortgages/Finances</p>
										{tabNotifications.MF > 0 && <span style={{ position: 'absolute', top: '0px', right: '0px', height: '19px', width: '19px', borderRadius: '50%', backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '10px' }}>{tabNotifications.MF}</span>}
									</div>
								</div>
								<div style={{ position: 'absolute', top: 65, left: 0, right: 0, bottom: 2, overflowY: 'scroll' }} onScroll={handleScroll}>
									<div style={{ margin: 'auto', padding: '0px 2%', color: 'black' }}>
										{getFilteredHistory('MF').map((item: Cases.caseHistoryItemState) => (
											<HistoryItem key={item.historyrowid} {...item} />
										))}
										{getFilteredHistory('MF').length === 0 &&
											<div  style={{marginLeft: '4px'}}>No Mortgages/Finances Found</div>
										}
									</div>
								</div>
							</div>
						}
					</div>
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);

}

export default HistoryList;